import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReferralFacebook = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 25,
		cy: 25,
		r: 24.5,
		fill: "white",
		stroke: "white"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M19.3548 25.7172H21.7664V35.6452C21.7664 35.8412 21.9252 36 22.1212 36H26.2101C26.4061 36 26.5649 35.8412 26.5649 35.6452V25.764H29.3372C29.5175 25.764 29.6691 25.6287 29.6897 25.4497L30.1108 21.7947C30.1224 21.6941 30.0905 21.5934 30.0232 21.518C29.9559 21.4425 29.8595 21.3992 29.7584 21.3992H26.5651V19.1081C26.5651 18.4175 26.937 18.0672 27.6705 18.0672C27.775 18.0672 29.7584 18.0672 29.7584 18.0672C29.9544 18.0672 30.1132 17.9083 30.1132 17.7124V14.3575C30.1132 14.1615 29.9544 14.0026 29.7584 14.0026H26.881C26.8607 14.0016 26.8156 14 26.7492 14C26.2499 14 24.5145 14.098 23.1437 15.3591C21.6249 16.7566 21.836 18.4299 21.8865 18.72V21.3992H19.3548C19.1588 21.3992 19 21.558 19 21.754V25.3623C19 25.5583 19.1588 25.7172 19.3548 25.7172Z",
		fill: "black"
	})]
});
export default SvgReferralFacebook;
